export default __webpack_public_path__ + "static/gearsOfWar-full-white-872aec045c1d3dc112e69e26837fda0b.svg";